import EnquiryAlertEmergency from 'client/pages/EnquiriesPage/components/EnquiryAlerts/EnquiryAlertEmergency/EnquiryAlertEmergency';
import EnquiryAlertError from 'client/pages/EnquiriesPage/components/EnquiryAlerts/EnquiryAlertError/EnquiryAlertError';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const EnquiryPageTitle = ({ children, className, isEmergency, error, showWarning, subtitleMessageId, ...props }) => {
    const intl = useIntl();
    return (
        <>
            { error ? <EnquiryAlertError/> : null}
            <h1
                className={[
                    'govuk-heading-xl govuk-!-margin-top-4 govuk-!-margin-bottom-2',
                    className
                ].join(' ') }
                {...props}
            >
                {children}
            </h1>
            {subtitleMessageId && (
                <p className="govuk-body govuk-!-margin-top-4 govuk-!-margin-bottom-4">
                    {intl.formatMessage({ id: subtitleMessageId })}
                </p>
            )}
            { !error && isEmergency ? <div className='govuk-!-margin-top-4'><EnquiryAlertEmergency/></div> : null}
        </>
    );
};

EnquiryPageTitle.propTypes = {
    ...defaultAriaProps,
    isEmergency: PropTypes.bool,
    error: PropTypes.string,
    showWarning: PropTypes.bool,
    subtitleMessageId: PropTypes.string
};

EnquiryPageTitle.defaultProps = {
    isEmergency: false,
    showWarning: true,
    subtitleMessageId: null
};

export default EnquiryPageTitle;
